import { useEffect, useCallback, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../../store';
import {
  fetchEmailSettings,
  saveEmailSettings,
  deleteEmailSettings,
  updateEmailSettings,
} from '../../store/slices/emailSettingsSlice';
import { EmailSettings } from '../../types/email-settings';

export const useEmailSettings = () => {
  const dispatch = useDispatch<AppDispatch>();

  // Select E-Mail settings state from Redux

  // Get selected organization ID
  const selectedOrganizationId = useSelector(
    (state: RootState) => state.organizationContext.selectedOrganizationId
  );

  // Prevent multiple API calls
  const isFetchingRef = useRef(false);

  const fetchEmailSettingsData = useCallback(() => {
    if (selectedOrganizationId && !isFetchingRef.current) {
      isFetchingRef.current = true;
      dispatch(fetchEmailSettings(selectedOrganizationId)).finally(() => {
        isFetchingRef.current = false;
      });
    }
  }, [dispatch, selectedOrganizationId]);

  useEffect(() => {
    fetchEmailSettingsData();
  }, [fetchEmailSettingsData]);

  const saveSettings = (settings: EmailSettings) => {
    if (selectedOrganizationId) {
      return dispatch(
        saveEmailSettings({ organizationId: selectedOrganizationId, emailSettings: settings })
      );
    }
  };

  const updateSettings = (settings: EmailSettings) => {
    if (selectedOrganizationId) {
      return dispatch(
        updateEmailSettings({ organizationId: selectedOrganizationId, emailSettings: settings })
      );
    }
  };

  const deleteSettings = () => {
    return dispatch(deleteEmailSettings(selectedOrganizationId || ''));
  };

  return {
    selectedOrganizationId,
    refetch: fetchEmailSettingsData,
    saveEmailSettings: saveSettings,
    updateEmailSettings: updateSettings,
    deleteEmailSettings: deleteSettings,
  };
};
